<template>
  <section class="account-container account-container-new" @click="gotoPricing()" :class="[account.plan, { 'cursor-pointer': ['advanced', 'professional'].includes(account.plan) }]">
    <div class="survey-popup-container" v-if="account.plan !== 'trial' && remainingDays <= 3 && remainingDays > 0">
      <SurveyTrial v-if="isOpenSurvey" @cancelSurvey="closeSurvey" :remainingDays="remainingDays" :accountName="accountName" />
    </div>
    <div class="account pr-0" :class="[account.plan]">
      <div class="gradient-bg"></div>
      <div class="content-info">
        <div class="d-flex align-items-center">
          <template>
            <a class="account-upgrade-link">
              <div class="image-wrapper">
                <img class="starter" v-if="account.plan == 'starter'" :src="publicPath + require('@/core/assets/pricing/starter_plan_icon.svg')" />

                <img class="trial" v-if="isTrial" :src="publicPath + require('@/core/assets/pricing/trial_plan_icon.svg')" />
                <img class="build" v-if="account.plan == 'build' || account.plan == 'professional'" :src="publicPath + require('@/core/assets/pricing/build_plan_icon.svg')" />
                <img class="optimize" v-if="account.plan == 'optimize' || account.plan == 'advanced'" :src="publicPath + require('@/core/assets/pricing/optimize_plan_icon.svg')" />
                <img class="enterprise" v-if="account.plan == 'enterprise'" :src="publicPath + require('@/core/assets/pricing/enterprise_plan_icon.svg')" />
              </div>
              <div class="plan-name" :class="account.plan">
                <span>{{ account.plan | planify | upper }}</span>
                <!-- <div v-if="isTrial" class="plan-desc">
                  <div class="flex-inline" :class="{ 'remaining-days': isTrial && remainingDays <= 3 }" @click="toggleSurvey">
                    <span class="typo-paragraph12" v-if="remainingDays">{{ $tc("banner.trial.day", remainingDays) }}&nbsp;</span>
                    <span class="typo-paragraph12 space" v-if="remainingDays && display == 3">{{ ` ${$tc("generals.account.left", remainingDays || 1)}` }}</span>
                    <span class="typo-paragraph12 space" v-if="remainingDays && display != 3">{{ ` ${$tc("generals.account.left", remainingDays || 1)}` }}</span>
                  </div>
                  <span class="typo-paragraph12" @click="gotoPricing" v-if="!remainingDays">{{ $t("generals.expired") }}</span>
                </div> -->
              </div>
            </a>
          </template>
        </div>
        <div class="see-plan-text" :class="{ upgrade: isTrial }">
          {{ isTrial ? $t("sidebar.account.upgrade") : $t("support.seePLan") }}
          <img v-if="!isTrial" :src="publicPath + require('@/core/assets/pricing/right_arrow_icon.svg')" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import upperFirst from "@/plugins/lodash/upperFirst.js";
import SurveyTrial from "@/core/components/SurveyTrial.vue";
import { mapGetters, mapState } from "vuex";
import Cookies from "@/utils/cookie.js";
import dynamicTriggerContent from "@/mixins/dynamicTriggerContent";
import { PLAN_NO, PLAN_NAMES } from "../../contants/plan";

const NEXT_SURVEY_POPUP_LOCAL_STORAGE = "NextSurveyPopup";

export default {
  name: "Account",
  components: {
    SurveyTrial
  },
  filters: {
    upper(value) {
      if (value)
        return value
          .trim()
          .split(" ")
          .map(word => {
            return upperFirst(word);
          })
          .join(" ");
      return "";
    },
    planify(value) {
      if (value == "plus") return "shopify plus";
      return PLAN_NAMES[value] || value;
    }
  },
  mixins: [dynamicTriggerContent()],
  props: {
    account: Object
  },
  data() {
    return {
      display: 3,
      isOpenSurvey: false
    };
  },
  computed: {
    ...mapState("account", {
      shopInfo: state => state.shopInfo,
      isModalPopup: state => state.isModalPopup
    }),
    ...mapGetters("notibar", {
      notiAction: "noti_action"
    }),
    isTrial() {
      return this.account.plan === PLAN_NO.TRIAL2022 || this.account.plan === PLAN_NO.TRIAL;
    },
    isViewNoti() {
      return this.notiAction.isViewingNoti;
    },
    isViewModal() {
      return this.isModalPopup;
    },
    accountName() {
      const { firstName, lastName } = this.account;
      return `${firstName} ${lastName}`;
    },
    remainingDays() {
      if (this.account.remainingDays < 0) return 0;
      return this.account.remainingDays;
    },
    isExpired() {
      if (this.account.remainingDays <= 0) return "expired";
      return "remain";
    }
    // planClass() {
    //   if (this.account && this.account.plan == "advanced") {
    //     return "text-accent-yellow";
    //   }
    //   return "text-mono2";
    // }
  },
  watch: {
    $route() {
      this.isOpenSurvey = false;
    },
    isViewNoti(value) {
      if (value) this.isOpenSurvey = false;
    },
    isViewModal(value) {
      if (value) this.isOpenSurvey = false;
    }
  },
  created() {
    this.onResize();
    window.addEventListener("resize", this.onResize);
    this.autoSurveyPopup();
  },
  methods: {
    gotoOutside() {
      if (!this.account || !this.account.plan || this.account.plan == PLAN_NO.TRIAL || this.account.plan == PLAN_NO.STARTER) {
        return;
      }
      this.gotoPricing();
    },
    gotoPricing() {
      if (this.$route.name == "Pricing") return;
      this.$router.replace({
        name: "Pricing",
        query: {
          from: this.dynamicTrigger.business_footer
        }
      });
    },
    onResize() {
      if (window.innerWidth >= 1440) {
        this.display = 3;
      } else if (window.innerWidth >= 1280) {
        this.display = 2;
      } else {
        this.display = 1;
      }
    },
    autoSurveyPopup() {
      if (this.account.plan != PLAN_NO.TRIAL && this.account.plan != PLAN_NO.TRIAL2022) return;
      if (this.remainingDays > 5 || this.remainingDays <= 0) return;

      const timeToDisplay = localStorage.getItem(NEXT_SURVEY_POPUP_LOCAL_STORAGE);
      const isAcceptCookiePopup = Cookies.get("cky-action");
      const isClosedSurvey = this.shopInfo?.extras?.trialSurveyClosed;

      if (!isAcceptCookiePopup) return;
      if (timeToDisplay > new Date() && isClosedSurvey) return;

      let expires = new Date();
      expires = expires.setHours(expires.getHours() + 24);
      localStorage.setItem(NEXT_SURVEY_POPUP_LOCAL_STORAGE, expires);

      return (this.isOpenSurvey = true);
    },
    closeSurvey() {
      this.isOpenSurvey = false;
    },
    toggleSurvey() {
      this.isOpenSurvey = !this.isOpenSurvey;
    }
  }
};
</script>
<style lang="scss" scoped>
.flex-inline {
  display: inline-flex;
}
.account-container-new {
  // max-height: 72px !important;
  background-color: #252525 !important;
  padding: 16px;
  position: fixed !important;
  margin-top: 0px !important;
  margin-bottom: 0px !important;
  bottom: 0px;
  width: 280px;
  cursor: pointer;
  border-top: unset !important;
  @media screen and (max-width: 1279px) {
    width: 224px;
    min-width: 224px;
  }
  &:hover {
    background-color: #494949 !important;
  }
}
.image-wrapper {
  width: 32px;
  height: 32px;
  display: flex;
  // align-items: center;
  justify-content: center;
  .advanced {
    width: 24px;
    height: 28px;
  }
  .trial,
  .trial2022,
  .optimize {
    width: 24px;
    height: 28px;
  }
  .professional {
    width: 24px;
    height: 24px;
    margin-top: 4px;
  }
  .starter {
    width: 28px;
    height: 24px;
    margin-top: 4px;
  }
  .build {
    width: 28px;
    height: 28px;
  }
  .enterprise {
    width: 32px;
    height: 24px;
    margin-top: 4px;
  }
}

.plan-name {
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  margin-left: 4px;
  &.advanced {
    color: #00c853;
  }
  &.optimize {
    color: #00c853;
  }
  &.build {
    color: #7190ff;
  }
  &.trial,
  &.trial2022 {
    color: #d6d6d6;
  }
  &.starter {
    color: #d8e1ff;
  }
  &.enterprise {
    color: #f88e86;
  }
  &.professional {
    color: #7190ff;
  }
}
.plan-desc {
  color: #aaaaaa !important;
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  margin-top: 4px;
}
.cursor-pointer {
  cursor: pointer;
}
.account-container {
  position: relative;

  &.professional {
    border-bottom: 4px solid $mono1;
  }

  &.advanced {
    border-bottom: 4px solid #ffb133;
  }
  .account {
    background: inherit;

    .content-info .upgrade-section {
      background-color: $mono3;
      color: $textDarkModeHigh;
      border-radius: $radius;
      justify-content: center;
      padding-top: 11px;
      padding-bottom: 12px;
      &.professional-plan {
        background-color: $dark2;
      }
      &:hover {
        background-color: $mono4;
      }
    }

    .content-info {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .see-plan-text {
        color: #e2e2e2;
        font-weight: 500;
        font-size: 14px;
        line-height: 20px;
        font-family: "Inter";
        font-style: normal;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          margin-left: 4px;
        }
        &.upgrade {
          color: #8aa4ff;
        }
      }
      .plan {
        .lighting {
          &-gem {
            filter: drop-shadow(0px 0px 10px rgba(140, 166, 255, 0.6));
          }
          &-diamond {
            filter: drop-shadow(0px 0px 10px rgba(113, 144, 255, 0.6));
          }
          &-crown {
            filter: drop-shadow(0px 0px 10px rgba(255, 177, 51, 0.6));
          }
        }
      }
    }

    .upgrade {
      font-weight: 500;
      font-size: 14px;
      line-height: 17px;
      justify-content: center;
      white-space: pre;
      // i.icon {
      //   font-weight: 500;
      //   font-size: 14px;
      //   line-height: 17px;
      //   @include trans-all;
      // }
    }

    .name {
      color: #fff;
      margin-bottom: 2px;
      cursor: pointer;
    }

    .plan {
      // max-height: 15px;
      white-space: pre !important;
      justify-content: center;
      .expired {
        color: $accent-red;
      }
      .remain {
        color: $accent-green;
      }
      > span {
        cursor: pointer;
      }
    }

    .remaining-days {
      &:hover {
        color: $accent-green;
        cursor: pointer;
      }
    }

    &.trial {
      .name {
        color: $black1;
      }
      .plan {
        color: $textDarkModeHigh;
      }
      .upgrade {
        color: $textDarkModeHigh;
      }
    }

    &.starter {
      .name {
        color: $black1;
      }
      .plan {
        color: $textDarkModeHigh;
      }
      .upgrade {
        color: $textDarkModeHigh;
      }
    }

    &.professional {
      .name {
        color: $black1;
      }
      .plan {
        color: $textDarkModeHigh;
        margin-bottom: auto;
      }
      .upgrade {
        color: $textDarkModeHigh;
      }

      .plan > span {
        cursor: default;
      }
    }

    .account-upgrade-link {
      width: 100%;
      display: flex;
      align-items: center;
      // justify-content: center;
    }

    &.advanced {
      .name {
        color: $black1;
      }
      .plan {
        // color: $accent-yellow;
        margin-bottom: auto;
      }
      .upgrade {
        color: $textDarkModeHigh;
      }
    }

    &.plus {
      // background: unset;
      background: $gradientDark;
      .upgrade {
        // color: $cYellow;
        display: none;
      }
      .plan {
        span:first-child {
          background: linear-gradient(207.6deg, #f36c26 16.18%, #fdb913 83.82%);
          -webkit-text-fill-color: transparent;
          background-clip: text;
          -webkit-background-clip: text;
          -moz-background-clip: text;
        }
      }
      .gradient-bg {
        background-image: url("data:image/svg+xml,%3Csvg width='81' height='67' viewBox='0 0 81 67' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg opacity='0.1'%3E%3Cpath d='M66.5317 37.3747L82.9689 23.7749L93.2422 48.4307L66.5317 37.3747Z' fill='url(%23paint0_linear)'/%3E%3Cpath d='M0.978516 10.3714L25.6343 0.0981445L27.6889 21.4274L0.978516 10.3714Z' fill='url(%23paint1_linear)'/%3E%3Cpath d='M0 12.6211L27.8845 24.0684L25.732 75.3368L0 12.6211ZM64.5747 39.1358L92.4592 50.5832L30.037 77.0001L64.5747 39.1358Z' fill='url(%23paint2_linear)'/%3E%3Cpath d='M31.9941 23.1882L54.3018 11.9365L62.2268 35.6139L31.9941 23.1882Z' fill='url(%23paint3_linear)'/%3E%3Cpath d='M27.9824 0L52.5404 10.0776L30.1349 21.4271L27.9824 0ZM56.8453 11.8387L81.4033 21.9163L64.8683 35.6139L56.8453 11.8387Z' fill='url(%23paint4_linear)'/%3E%3Cpath d='M27.9824 0L52.5404 10.0776L30.1349 21.4271L27.9824 0ZM56.8453 11.8387L81.4033 21.9163L64.8683 35.6139L56.8453 11.8387Z' fill='url(%23paint5_linear)'/%3E%3Cpath d='M30.2326 25.0469L62.2264 38.1575L28.0801 75.6304L30.2326 25.0469Z' fill='url(%23paint6_linear)'/%3E%3Cpath d='M30.2326 25.0469L62.2264 38.1575L28.0801 75.6304L30.2326 25.0469Z' fill='url(%23paint7_linear)'/%3E%3C/g%3E%3Cdefs%3E%3ClinearGradient id='paint0_linear' x1='93.2422' y1='36.1028' x2='72.1852' y2='47.0136' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%23F36C26'/%3E%3Cstop offset='1' stop-color='%23FDB913'/%3E%3C/linearGradient%3E%3ClinearGradient id='paint1_linear' x1='27.6889' y1='10.7628' x2='8.03108' y2='22.5372' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%23F36C26'/%3E%3Cstop offset='1' stop-color='%23FDB913'/%3E%3C/linearGradient%3E%3ClinearGradient id='paint2_linear' x1='92.4592' y1='44.8106' x2='29.6411' y2='87.9615' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%23F36C26'/%3E%3Cstop offset='1' stop-color='%23FDB913'/%3E%3C/linearGradient%3E%3ClinearGradient id='paint3_linear' x1='62.2268' y1='23.7752' x2='40.2071' y2='37.2231' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%23F36C26'/%3E%3Cstop offset='1' stop-color='%23FDB913'/%3E%3C/linearGradient%3E%3ClinearGradient id='paint4_linear' x1='81.4033' y1='17.807' x2='46.1357' y2='43.1096' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%23F36C26'/%3E%3Cstop offset='1' stop-color='%23FDB913'/%3E%3C/linearGradient%3E%3ClinearGradient id='paint5_linear' x1='81.4033' y1='17.807' x2='46.1357' y2='43.1096' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%23F36C26'/%3E%3Cstop offset='1' stop-color='%23FDB913'/%3E%3C/linearGradient%3E%3ClinearGradient id='paint6_linear' x1='62.2264' y1='50.3386' x2='31.3037' y2='60.3228' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%23F36C26'/%3E%3Cstop offset='1' stop-color='%23FDB913'/%3E%3C/linearGradient%3E%3ClinearGradient id='paint7_linear' x1='62.2264' y1='50.3386' x2='31.3037' y2='60.3228' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%23F36C26'/%3E%3Cstop offset='1' stop-color='%23FDB913'/%3E%3C/linearGradient%3E%3C/defs%3E%3C/svg%3E%0A");
        position: absolute;
        bottom: -11px;
        right: -20px;
        width: 93.24px;
        height: 77px;
        background-repeat: no-repeat;
      }
    }

    &.agency {
      background: $gradientBlue;
      .upgrade {
        color: $cYellow;
      }
      .plan {
        color: #00cae0;
      }
    }

    &:hover {
      .upgrade {
        i.icon.icon-arrow-right {
          transform: translateX(8px);
        }
      }
    }
  }
}
.upgrade,
.plan {
  display: flex;
}

.upgrade {
  margin-left: auto;
  align-items: center;
  color: inherit;
}

.arrow {
  transform: rotate(-90deg);
  margin-left: 8px;
  margin-right: 14px;
  color: map-get($light-grey, "600");
}
.space {
  margin-left: 3px;
}
</style>
